export const LOCAL_STORAGE_KEYS = {
    rightNavBarClosed: 'right-nav-bar-closed',
    // Intentionally a single global key shared across all payroll runs/companies for a browser
    // profile, not scoped per payroll or company. Column layouts are expected to be similar
    // enough across runs that sharing one set of widths is preferable to re-prompting the user
    // to resize columns every time they open a different payroll.
    payrollRunColumnWidths: 'payroll-run-column-widths',
};
